import { render } from "./TheChucDanh.vue?vue&type=template&id=55b4e7b3"
import script from "./TheChucDanh.vue?vue&type=script&lang=js"
export * from "./TheChucDanh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__